import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import MobileNav from './MobileNav';
import { useIsMobile } from '../../hooks/useResponsive';

const Layout = () => {
  const isMobile = useIsMobile();
  const location = useLocation();
  
  // Check if we're on settings page (has different layout on desktop)
  const isSettingsPage = location.pathname === '/settings';

  return (
    <div className="flex h-screen w-full overflow-hidden">
      {/* Desktop Sidebar */}
      {!isMobile && <Sidebar />}
      
      {/* Main Content */}
      <main className="flex-1 flex flex-col h-full overflow-hidden bg-white relative">
        <Outlet />
      </main>

      {/* Mobile Bottom Navigation */}
      {isMobile && <MobileNav />}
    </div>
  );
};

export default Layout;
